/**
 * crypto.randomUUID() only exists in secure contexts (HTTPS, or the
 * "localhost" origin specifically) — on plain HTTP at any other hostname or
 * IP (e.g. a LAN address before a reverse proxy/TLS is set up), it's simply
 * undefined and calling it throws immediately. crypto.getRandomValues(),
 * however, has no such restriction, so we fall back to building a v4 UUID
 * from it by hand when the convenience method isn't available.
 */
export function randomUUID(): string {
  if (typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
